import { UserButton } from '@/components'
import { Jobibot } from '@/ui'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/account')({
	component: AccountLayout,
})

function AccountLayout() {
	return (
		<div className="min-h-screen w-screen [--main-nav-height:55px]">
			<div className="bg-white px-10 sticky top-0 z-20 border-b border-grey-100 h-[var(--main-nav-height)] flex items-center justify-between">
				<Link to="/company">
					<Jobibot size={28} />
				</Link>
				<UserButton />
			</div>
			<Outlet />
		</div>
	)
}
